import create, { GetState, SetState } from 'zustand';
import { BaseQueryState } from './interfaces/CreateQueryState';
import { createCommonBaseQuerySlice } from './slices/BaseQuerySlices/CommonBaseQuerySlice';
import { createBaseQuerySlice } from './slices/BaseQuerySlices/CreateBaseQuerySlice';

export const useBaseQueryStore = create<BaseQueryState>(
  (set: SetState<BaseQueryState>, get: GetState<BaseQueryState>) => ({
    ...createBaseQuerySlice(set, get),
    ...createCommonBaseQuerySlice(set)
  })
);
